import { env } from './EnvironmentConfig'

export const API_BASE_URL = env.API_ENDPOINT_URL;

const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/send/text/basic',
    unAuthenticatedEntryPath: '/sign-in',
    secAuthenticatedEntryPath: '/sec-sign-in',
    tourPath: '/',
    locale: 'ko',
    enableMock: true,
}

export default appConfig
